export const CodeGradient = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20" fill="none">
      <path
        // eslint-disable-next-line max-len
        d="M15.3981 0.244299C14.7605 0.0605347 14.0967 0.431814 13.9129 1.06936L9.11257 17.8707C8.92881 18.5082 9.30008 19.172 9.93763 19.3558C10.5752 19.5396 11.239 19.1683 11.4228 18.5307L16.2231 1.72942C16.4069 1.09187 16.0356 0.428063 15.3981 0.244299ZM18.4208 4.7484C17.952 5.21719 17.952 5.9785 18.4208 6.44728L21.7698 9.80005L18.417 13.1528C17.9483 13.6216 17.9483 14.3829 18.417 14.8517C18.8858 15.3205 19.6471 15.3205 20.1159 14.8517L24.3163 10.6514C24.785 10.1826 24.785 9.42127 24.3163 8.95248L20.1159 4.75215C19.6471 4.28336 18.8858 4.28336 18.417 4.75215L18.4208 4.7484ZM6.91865 4.7484C6.44986 4.27961 5.68855 4.27961 5.21977 4.7484L1.01944 8.94873C0.55065 9.41752 0.55065 10.1788 1.01944 10.6476L5.21977 14.8479C5.68855 15.3167 6.44986 15.3167 6.91865 14.8479C7.38743 14.3792 7.38743 13.6178 6.91865 13.1491L3.56589 9.80005L6.91865 6.44728C7.38743 5.9785 7.38743 5.21719 6.91865 4.7484Z"
        fill="url(#paint0_linear_264_3031)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_264_3031"
          x1="0.667847"
          y1="9.80005"
          x2="24.6678"
          y2="9.80005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
